import React, { useState } from 'react';

interface ControlPanelProps {
  mode: 'mock' | 'live';
  context?: {
    runId?: string;
    deviceKey?: string;
    ticketStatus?: string;
  };
  onShowErrorUi05?: () => void;
}

export const ControlPanel: React.FC<ControlPanelProps> = ({ mode, context, onShowErrorUi05 }) => {
  const [ticketInput, setTicketInput] = useState('');

  const updateSearchParams = (next: URLSearchParams) => {
    const query = next.toString();
    const suffix = query ? `?${query}` : '';
    window.location.search = suffix;
  };

  const handleLoadTicket = (event: React.FormEvent) => {
    event.preventDefault();
    const params = new URLSearchParams(window.location.search);
    if (ticketInput.trim().length > 0) {
      params.set('ticket', ticketInput.trim());
      params.delete('mode');
    } else {
      params.delete('ticket');
    }
    updateSearchParams(params);
  };

  const handleSwitchMock = () => {
    const params = new URLSearchParams(window.location.search);
    params.set('mode', 'mock');
    params.delete('ticket');
    updateSearchParams(params);
  };

  return (
    <section className="control-panel">
      <div className="control-panel__column">
        <p className="eyebrow">現在のモード</p>
        <strong>{mode === 'live' ? 'API接続中' : 'モック'}</strong>
        {mode === 'live' && context?.ticketStatus && <p className="eyebrow subtle">Ticket: {context.ticketStatus}</p>}
        <button className="ghost-btn" onClick={handleSwitchMock}>
          モックモードで再読み込み
        </button>
      </div>
      <div className="control-panel__column">
        <p className="eyebrow">Ticketを読み込む</p>
        <form className="control-panel__form" onSubmit={handleLoadTicket}>
          <input
            placeholder="tkt_live_xxx"
            value={ticketInput}
            onChange={(event) => setTicketInput(event.target.value)}
          />
          <button className="secondary-btn" type="submit">
            反映
          </button>
        </form>
      </div>
      <div className="control-panel__column">
        <p className="eyebrow">デバイスキー</p>
        <code>{context?.deviceKey ?? '(mock device)'}</code>
        {context?.runId && (
          <>
            <p className="eyebrow subtle">Run ID</p>
            <code>{context.runId}</code>
          </>
        )}
        {onShowErrorUi05 && (
          <button className="ghost-btn" type="button" onClick={onShowErrorUi05}>
            UI05（エラーUI）を表示（テスト）
          </button>
        )}
      </div>
    </section>
  );
};

